<template>
  <svg
    :class="customClass"
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4768 5.66591L6.00683 1.19591L7.18516 0.0175781L13.6668 6.49924L7.18516 12.9809L6.00683 11.8026L10.4768 7.33258H0.333496V5.66591H10.4768Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "ArrowRight",
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },
};
</script>
